
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#toggle_icon_svg__clip0_861_50518)"}},[_c('path',{attrs:{"d":"M18 7H6c-3.312 0-6 2.688-6 6s2.688 6 6 6h12c3.312 0 6-2.688 6-6s-2.688-6-6-6zm0 9.6a3.595 3.595 0 01-3.6-3.6c0-1.992 1.608-3.6 3.6-3.6s3.6 1.608 3.6 3.6-1.608 3.6-3.6 3.6z","fill":"#54D28C"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"toggle_icon_svg__clip0_861_50518"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    